import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker on mobile devices only (enables PWA Add-to-Home-Screen).
// Desktop browsers continue with unregister() — zero behavioral change.
const isMobileDevice = (
  window.matchMedia('(max-width: 768px)').matches &&
  ('ontouchstart' in window || navigator.maxTouchPoints > 0)
);

if (isMobileDevice) {
  serviceWorkerRegistration.register();
} else {
  serviceWorkerRegistration.unregister();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
